export default {
  videos: undefined,
  cancel: undefined,
  photos: undefined,
  albums: undefined,
  search: undefined,
  press: undefined
}